// pages/ResultsPage.jsx
import { Typography, Box } from "@mui/material";
import PageShell from "../components/PageShell";
import Results from "../results/Results";

/**
 * ResultsPage.jsx
 * Wraps the Results component inside the main ARL layout (PageShell)
 */
export default function ResultsPage({data}) {
  return (
    <PageShell title="Results" bannerImage="join2.png">
      <Results data={data}/>
    </PageShell>
  );
}
